import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';

import Map from './tier_prefectures/Map.js';
import Search from './tier_prefectures/Search.js';

class TierPrefectures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefecture: null,
      prefectureTiers: null
    };
  }

  componentDidMount() {
    fetch('/api/find_comparable_markets/tiers').then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ prefectureTiers: respJson });
      });
  }

  updateTierPrefectures(newState) {
    this.setState(newState);
  }

  render() {
    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Find Comparable Markets</div>
            <h1 className="sl-view-title">Select A Prefecture</h1>
            <p className="sl-view-subtitle">Use the map and search to choose a prefecture within your selected tier.</p>
          </div>
          <span className="sl-view-meta">Step 2 of 4</span>
        </div>

        <Row className="sl-grid-gap">
          <Col md="6">
            <Map
              tier={this.props.tier}
              prefectureTiers={this.state.prefectureTiers} />
            <Button color="primary" tag="a" href="/find_comparable_markets/index" className="sl-inline-action" outline>
              Back to Tiers
            </Button>
          </Col>
          <Col md="6">
            <Search
              tier={this.props.tier}
              updateTierPrefectures={this.updateTierPrefectures.bind(this)} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default TierPrefectures;
